import React from 'react';

import {assertAndContinue} from 'Asserts';
import {SAMPLE_RESTRICTION_STATUS_LABELS, SampleRestrictionStatus} from 'constants/SampleStatusConstants';
import OptionCellDropdown from 'notebook/plain-tables/selectors/OptionCellDropdown';
import {BaseTypedValueType, TypedValue} from 'notebook/tables/TableConstants';

interface SampleRestrictionStatusTypedValueSelectorProps {
  onUpdate: (tv: TypedValue) => void;
  typedValue: TypedValue | null;
  locked?: boolean;
}

export default function SampleRestrictionStatusTypedValueSelector(
  props: SampleRestrictionStatusTypedValueSelectorProps
): JSX.Element {
  const options = Object.values(SampleRestrictionStatus).map((status) => ({
    node: <span>{SAMPLE_RESTRICTION_STATUS_LABELS[status]}</span>,
    onUpdateKey: status,
  }));
  const currentStatus =
    props.typedValue?.type === BaseTypedValueType.SAMPLE_RESTRICTION_STATUS
      ? (props.typedValue.status as SampleRestrictionStatus)
      : SampleRestrictionStatus.UNRESTRICTED;
  const displayStatus = SAMPLE_RESTRICTION_STATUS_LABELS[currentStatus];

  if (props.locked) {
    return <span>{displayStatus}</span>;
  }

  return (
    <div className="u-position-relative">
      <OptionCellDropdown
        locked={false}
        isSelected={true}
        staticDisplay={displayStatus}
        options={options}
        onUpdate={(selectedStatus) => {
          const newStatus = Object.values(SampleRestrictionStatus).find(
            (status) => status === selectedStatus
          );
          assertAndContinue(newStatus != null, `Invalid status selected: ${newStatus}`);
          props.onUpdate({
            type: BaseTypedValueType.SAMPLE_RESTRICTION_STATUS,
            status: newStatus as SampleRestrictionStatus,
          });
        }}
        fullWidth={true}
        lightHoverBackground={true}
      />
    </div>
  );
}
